import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthLayout } from "@/components/AuthLayout";
import { Button } from "@/components/ui/Button";
import { Field } from "@/components/ui/Field";
import { useAuth } from "@/contexts/AuthContext";

// Réplica de reference/expo-frontend/app/forgot-password.tsx: envia um
// código de 6 dígitos por e-mail e navega para a redefinição.
export default function ForgotPasswordPage() {
  const { forgotPassword } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!email.trim()) {
      setError("Informe seu e-mail.");
      return;
    }
    setError(null);
    setLoading(true);
    const result = await forgotPassword(email.trim());
    setLoading(false);
    if (result.error) setError(result.error);
    else navigate(`/reset-password?email=${encodeURIComponent(email.trim())}`);
  };

  return (
    <AuthLayout
      title="Recuperar senha"
      subtitle="Informe seu e-mail e enviaremos um código para redefinir a senha."
    >
      <form onSubmit={onSubmit} className="flex flex-col gap-4.5">
        <Field
          label="E-mail"
          tone="auth"
          type="email"
          autoComplete="email"
          placeholder="seu@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={loading}
        />

        {error && (
          <p className="rounded-(--radius-field) bg-destructive/15 px-4 py-3 text-sm text-[#ffb4ad]">
            {error}
          </p>
        )}

        <Button
          type="submit"
          title="Enviar código"
          loading={loading}
          className="mt-1"
        />
      </form>

      <div className="mt-6 flex justify-center">
        <Link
          to="/login"
          className="text-[13px] font-bold text-surface-alt-foreground/50"
        >
          Voltar para o login
        </Link>
      </div>
    </AuthLayout>
  );
}
